import handleToggle from '../common/handleToggle';
import registerInputEvents from './registerInputEvents';
import toggleRadio from './toggleRadio';

// define input types for standard behaviour
const inputTypes = [
    'text',
    'password',
    'email',
    'tel',
    'search',
];

$('.form').each((_, component) => {
    $(component)
        .find('input')
        .filter((_, input) => inputTypes.includes(input.type))
        .add($(component).find('textarea'))
        .each((_, input) => {
            registerInputEvents(input);
            const hasValue = Boolean(input.value.length);
            handleToggle(input, hasValue)();
        });

    $(component).on('change', 'input[type="radio"]', (e) => {
        toggleRadio(e.target);
    });

    $(component).on('change', 'select', (e) => {
        handleToggle(e.target, true)();
    });
});

// init datepicker
// https://www.npmjs.com/package/@chenfengyuan/datepicker
$('.form-datepicker').each((_, elem) => {
    const format = $(elem).attr('data-dateformat');
    const language = $(elem).attr('data-datelanguage');
    $(elem)
        .datepicker({
            format,
            language,
            autoHide: true,
        });
});



// WEBPACK FOOTER //
// ./src/scripts/components/form/index.js